export const normalizePhoneNumber = (phone) =>
  String(phone ?? '')
    .replace(/[۰-۹]/g, (digit) => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(digit)))
    .replace(/[٠-٩]/g, (digit) => String('٠١٢٣٤٥٦٧٨٩'.indexOf(digit)))
    .replace(/(?!^\+)[^0-9]/g, '');

export default function openTel(phone) {
  const normalizedPhone = normalizePhoneNumber(phone);

  if (!normalizedPhone) return false;

  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({ data: { openTel: { phone: normalizedPhone } } })
    );
    return true;
  }

  return false;
}
